/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CPSheetProblemsManagementDash from "../../../components/CPSheet/Problems";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const CPSheetProblems = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.cpSheetManagement?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CPSheetProblemsManagementDash
        adminConfig={userConfig?.cpSheetManagement}
        ROOT_URL={ROOT_URL}
      />
    </>
  );
};

export default CPSheetProblems;
